import { ReconOutstandingPage } from "@/features/recon-bank/pages/ReconOutstandingPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-outstanding/")({
	// Keep the active tab in the URL (?tab=) so refresh + link-sharing preserve it.
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
	}),
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconOutstandingPage,
});
